<script>
  import { setContext } from 'svelte'
  import { tweened } from 'svelte/motion'
  import { interpolateLab } from 'd3-interpolate'
  import { keyToProp } from './util/keys'
  import { fargetema } from '../../stores/fargetema'
  import Bakgrunn from './bakgrunn.svelte'

  let el

  const { matches: prefersReducedMotion } =
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)')

  setContext('animate', prefersReducedMotion === false)

  const duration = prefersReducedMotion ? 0 : 300

  const tema = tweened($fargetema, {
    duration: 0,
    interpolate: (start, target) => (t) => {
      const obj = {}
      for (const color in start) {
        obj[color] = interpolateLab(start[color], target[color])(t)
      }

      return obj
    },
  })

  $: tema.set($fargetema, { duration })

  $: if (el) {
    Object.keys($tema).forEach((key) => {
      el.style.setProperty(keyToProp(key), $tema[key])
    })
  }
</script>

<style>
  .root {
    position: relative;
  }
</style>

<div bind:this={el} class="root">
  <Bakgrunn />
  <slot />
</div>
